import {
    CHAT_IA_INIT,
    CHAT_IA_SUCCESS,
    CHAT_IA_GET_HISTORICO_INIT,
    CHAT_IA_GET_HISTORICO_SUCCESS,
    ERROR_CHAT_IA,
    CLEAR_CHAT_IA
} from '../actionTypes';

const INIT_STATE = {
    loading: false,
    response: null,
    historico: null,
    error: '',
    isError: false
};

const ChatIaReducer = (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case CHAT_IA_INIT:
            return {
                ...state,
                loading: true,
                isError: false,
                response: null,
                error: ''
            };
        case CHAT_IA_SUCCESS: {
            const { response } = action.payload;
            return {
                ...state,
                loading: false,
                response,
                isError: false,
                error: ''
            };
        }
        case CHAT_IA_GET_HISTORICO_INIT:
            return {
                ...state,
                loading: true,
                isError: false,
                error: ''
            };
        case CHAT_IA_GET_HISTORICO_SUCCESS: {
            const { historico } = action.payload;
            return {
                ...state,
                loading: false,
                historico,
                isError: false,
                error: ''
            };
        }
        case ERROR_CHAT_IA: {
            const { error } = action.payload;
            return {
                ...state,
                loading: false,
                isError: true,
                error
            };
        }
        case CLEAR_CHAT_IA: {
            return {
                ...INIT_STATE
            };
        }
        default:
            return state;
    }
};

export default ChatIaReducer;
